module.exports = __webpack_public_path__ + "img/140.88d27c16.jpg";